// Messages brefs en bas d'écran : chaque opération dit ce qu'elle a fait et
// son ampleur (RG-TRV-7).

import {
  createContext, useCallback, useContext, useEffect, useRef, useState,
  type ReactNode,
} from 'react';

const DUREE = 3500;

type Poster = (texte: string, duree?: number) => void;

const Contexte = createContext<Poster>(() => {});

export function FournisseurMessage({ children }: { children: ReactNode }) {
  const [texte, setTexte] = useState('');
  const [visible, setVisible] = useState(false);
  const minuteur = useRef<ReturnType<typeof setTimeout> | null>(null);

  const poster = useCallback<Poster>((t, duree) => {
    setTexte(t);
    setVisible(true);
    if (minuteur.current) clearTimeout(minuteur.current);
    minuteur.current = setTimeout(() => setVisible(false), duree || DUREE);
  }, []);

  useEffect(() => () => {
    if (minuteur.current) clearTimeout(minuteur.current);
  }, []);

  return (
    <Contexte.Provider value={poster}>
      {children}
      <div className={'toast' + (visible ? ' show' : '')}>{texte}</div>
    </Contexte.Provider>
  );
}

export function useMessage(): Poster {
  return useContext(Contexte);
}
